import React from 'react';
import { RefShareOrder } from '../../../../api/services';

interface PlatformIncomeCellProps {
  order: RefShareOrder;
}

const PLATFORM_COMMISSION = 5; // Platform's fixed 5%

const PlatformIncomeCell: React.FC<PlatformIncomeCellProps> = ({ order }) => {
  // Calculate platform income (5% from total revenue)
  const totalRevenue = Number(order.transactions_statistic?.total || 0);
  const platformIncome = totalRevenue * (PLATFORM_COMMISSION / 100);

  return (
    <div className="flex items-center gap-2 py-2">
      <span className="text-[14px] font-semibold text-[#11181C]">
        ${platformIncome.toFixed(2)}
      </span>
      <span className="text-[14px] text-[#71717A]">
        (5%)
      </span>
    </div>
  );
};

export default PlatformIncomeCell;
